import { Box, ButtonGroup } from '@mui/material'
import { ZoomIn as ZoomInIcon, ZoomOut as ZoomInOut } from '@mui/icons-material'
import { BookingZoomButton } from './components'
import { BookingZoomProps } from './types'
import { BookingZIndexLayers } from './enums'

export function BookingZoom({ factor, onZoom, top = 5 }: BookingZoomProps) {

  const {
    BOOKING_FLOORPLAN_VIEW_ZOOM_CONTROLS
  } = BookingZIndexLayers

  return (
    <Box id="zoom" position="absolute" right={12} top={top} zIndex={BOOKING_FLOORPLAN_VIEW_ZOOM_CONTROLS}>
      <ButtonGroup orientation="vertical" variant="contained">
        <BookingZoomButton onClick={() => onZoom(factor)}>
          <ZoomInIcon style={{ color: 'white' }} />
        </BookingZoomButton>
        <BookingZoomButton onClick={() => onZoom(-factor)}>
          <ZoomInOut style={{ color: 'white' }} />
        </BookingZoomButton>
      </ButtonGroup>
    </Box>
  )
}
